import { render, staticRenderFns } from "./platFormOrder.vue?vue&type=template&id=c92e6b30&scoped=true&"
import script from "./platFormOrder.vue?vue&type=script&lang=js&"
export * from "./platFormOrder.vue?vue&type=script&lang=js&"
import style0 from "./platFormOrder.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./platFormOrder.vue?vue&type=style&index=1&id=c92e6b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92e6b30",
  null
  
)

export default component.exports